import React from 'react';
import {
  Plugins,
  TypeImplementation,
  setType,
  withSystem,
} from '@packages/systems/wfdl';
import {TBoolean, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {type ContextualExpression} from '@packages/utilities/contextual-expression';
import {AUTOPLAY, PRIVACY_MODE, TOOLTIP_TEXT} from '../constants';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {HelpCircleIcon, HStack, Tooltip} from '@packages/systems/spring';

const type = {
  [AUTOPLAY]: withSystem(
    {label: 'Autoplay', labelVariant: 'hidden'},
    TTypeConstructor(
      qualify(Plugins.name('Basic'), typeName('ReverseLabelBoolean'))
    )
  ),
  [PRIVACY_MODE]: withSystem(
    {label: 'Privacy mode', labelVariant: 'hidden'},
    TTypeConstructor(
      qualify(Plugins.name('Basic'), typeName('ReverseLabelBoolean'))
    )
  ),
} as const;

const TooltipRender =
  (key: typeof AUTOPLAY | typeof PRIVACY_MODE) =>
  ({
    expr,
    dispatch,
  }: {
    expr: ContextualExpression;
    dispatch: TypeImplementation.ExpressionEditorDispatch;
  }) => {
    const nextExpr = setType(expr, type[key]);

    return (
      <HStack spacing={0.5}>
        <ExpressionEditor expression={nextExpr} dispatch={dispatch} />
        <Tooltip label={TOOLTIP_TEXT[key]}>
          <HelpCircleIcon size={12} />
        </Tooltip>
      </HStack>
    );
  };

export const AutoplayTooltip = TypeImplementation.Alias({
  type: TBoolean,
  render: TooltipRender(AUTOPLAY),
});

export const PrivacyModeTooltip = TypeImplementation.Alias({
  type: TBoolean,
  render: TooltipRender(PRIVACY_MODE),
});
